import { HomePageSection } from "@/store/undoable-state"
import { routes } from "@/utils/routes"

export const HOME_PATHS = [
	routes.root.build(),
	routes.styles.build(),
	routes.styleCreate.build(),
	routes.tutorials.build(),
	routes.support.build(),
	routes.settings.build(),
	routes.account.build(),
	routes.projects.build(),
] as const

const STYLE_DETAIL_PATH_PREFIX = routes.styleDetail.pathPrefix

export type HomePath = (typeof HOME_PATHS)[number]

export const homePathSet = new Set<HomePath>(HOME_PATHS)

export const homeSectionToPath: Record<HomePageSection, HomePath> = {
	projects: routes.projects.build(),
	ai_styles: routes.styles.build(),
	tutorials: routes.tutorials.build(),
	support: routes.support.build(),
	settings: routes.settings.build(),
	my_account: routes.account.build(),
}

export const pathToHomeSection: Record<HomePath, HomePageSection> = {
	[routes.root.build()]: "projects",
	[routes.styles.build()]: "ai_styles",
	[routes.styleCreate.build()]: "ai_styles",
	[routes.tutorials.build()]: "tutorials",
	[routes.support.build()]: "support",
	[routes.settings.build()]: "settings",
	[routes.account.build()]: "my_account",
	[routes.projects.build()]: "projects",
}

export const getPathForHomeSection = (section: HomePageSection): HomePath =>
	homeSectionToPath[section] ?? routes.root.build()

export const getSectionForPath = (pathname: string): HomePageSection | null => {
	if (isStyleDetailPath(pathname)) {
		return "ai_styles"
	}

	if (!isHomePath(pathname)) {
		return null
	}

	return pathToHomeSection[pathname] ?? null
}

export const isHomePath = (pathname: string): pathname is HomePath => homePathSet.has(pathname)

export const isStyleDetailPath = (pathname: string): boolean => {
	if (!STYLE_DETAIL_PATH_PREFIX) {
		return false
	}

	if (!pathname.startsWith(STYLE_DETAIL_PATH_PREFIX)) {
		return false
	}

	const remaining = pathname.slice(STYLE_DETAIL_PATH_PREFIX.length)
	return remaining.length > 0
}
